import ajv from '../ajv';

const noop = () => true;

/**
 * Build the validator for a context
 * @private
 * @param {*} propertyDefinitions The definitions of properties passed into createCustomElement's config.properties
 * @returns {Function(properties, host)} The function to validate the component's properties
 */
function buildContextValidator(schema) {
	if (!schema) return noop;

	if (process.env.NODE_ENV !== 'production') {
		let validate;
		try {
			validate = ajv.compile(schema);
		} catch (e) {
			console.error(e); // eslint-disable-line no-console
			return () => false;
		}

		return validate;
	}

	return noop;
}

export default buildContextValidator;
